export const environment = {
  production: true,
  guaranteesV2Enabled: undefined as boolean | undefined,
  healthManagerApiUrl: 'https://api.release.getlilo.io/health-manager',
  authorizationApiUrl: 'https://api.release.getlilo.io/access',
  protectedApiUrl: 'https://api.release.getlilo.io/protected',
  guaranteesHubUrl: 'https://api.release.getlilo.io/hubs/guarantees',
  adminPortalUrl: 'https://admin-portal-v2.release.getlilo.io',
  connectChatUrl: 'https://agent.connect-stg.twelvco.world',
  communicationServiceUrl: 'https://lilo-common-release-cs.europe.communication.azure.com/',
  firebase: {
    apiKey: 'AIzaSyBfMW3y0OnaAFnXSOYzgdi9ASOJLU-YyTE',
    authDomain: 'lilo-staging-9d37f.firebaseapp.com',
    projectId: 'lilo-staging-9d37f',
    storageBucket: 'lilo-staging-9d37f.firebasestorage.app',
    messagingSenderId: '102050866616',
    appId: '1:102050866616:web:6be433a33c061f826bdb4d',
    measurementId: 'G-4VHYXM270K',
    vapidKey: 'BGvlSVZx14p-SvE5AxDmgIyTxqJab4p9Hz0Y3zw-W6m5_qOxtJril7K2kK3kdJ62_zVvexIgwyPHRuKm46M6jN8',
  },
};
